module.exports = __webpack_public_path__ + "static/contact-bc59b35542f7b588effc0bde838b30e9.svg";